module.exports = __webpack_public_path__ + "pdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pdf.png
// module id = 390
// module chunks = 0